<template>
    <div class="marketing_view">
        <div class="fz14">
            更懂你的营销体系，始终以营销队伍为中心，聚焦市场趋势与客户需求，真正为团队赋予价值。尊崇自主经营，扁平化事务所架构，尽显精英化协同作战势能。
        </div>
        <div>
            <img src="../assets/images/picture_52.png" alt="">
        </div>
    </div>
</template>
<script>
export default {
    name: 'advantageMarketing'
}
</script>
<style lang="less" scoped>
.marketing_view {
    width: 1024px;
    margin: 0 auto;

    img {
        width: 848px;
        display: block;
        margin: 50px auto;
    }
}
</style>